module.exports = "/images/aerial-19.jpg";